import React from "react";
import dynamic from "next/dynamic";
import { DateTime as DT } from "luxon";
import Head from "next/head";
import Link from "next/link";
import styles from "../../Calendar/index.module.scss";
import EllipseYellow from "../../Calendar/assets/ellipse2.svg";
import CheckIcon from "../../Calendar/assets/check.svg";
import DocIcon from "../../Calendar/assets/doc.svg";
import CalendarIcon from "../../Calendar/assets/calendar22.svg";
import EllipseGreen from "../../Calendar/assets/ellipse1.svg";
import { track } from "../../../utils/amplitude";
import InAppSubscriptionForm from "../InAppSubscriptionForm";
import { ReactComponent as Img } from "./assets/bg.svg";
import styles2 from "./index.module.scss";

const AppleFiscalCalendar = dynamic(() =>
  import("../../Calendar/Type2/AppleFiscalCalendar")
);

const quarter = (label, months = []) => {
  return {
    label,
    months,
  };
};

const month = (date, from, to, events = [], headingText = null) => {
  return {
    date,
    period: {
      from,
      to,
    },
    headingText,
    events,
  };
};

const quarters = [
  quarter("Sep 25 - Dec 31", [
    month(
      DT.fromISO("2022-10-01"),
      DT.fromISO("2022-09-25"),
      DT.fromISO("2022-10-29"),
      [
        {
          date: DT.fromISO("2022-09-29").startOf("day"),
          disabled: true,
        },
        {
          date: DT.fromISO("2022-10-27").startOf("day"),
          disabled: true,
        },
      ],
      "Dec 1, 2022"
    ),
    month(
      DT.fromISO("2022-11-01"),
      DT.fromISO("2022-10-30"),
      DT.fromISO("2022-11-26"),
      [],
      "Dec 29, 2022"
    ),
    month(
      DT.fromISO("2022-12-01"),
      DT.fromISO("2022-11-27"),
      DT.fromISO("2022-12-31"),
      [
        {
          date: DT.fromISO("2022-12-01").startOf("day"),
          focusDate: DT.fromISO("2022-10-01").startOf("day"),
          paymentDate: "December 1, 2022",
          salesPeriod: "September 25 - October 29",
        },
        {
          date: DT.fromISO("2022-12-29").startOf("day"),
          focusDate: DT.fromISO("2022-11-01").startOf("day"),
          paymentDate: "December 29, 2022",
          salesPeriod: "October 30 - November 26",
        },
      ],
      "Feb 2, 2023"
    ),
  ]),

  quarter("Jan 1 - Apr 1", [
    month(
      DT.fromISO("2023-01-01"),
      DT.fromISO("2023-01-01"),
      DT.fromISO("2023-02-04"),
      [
        {
          date: DT.fromISO("2023-02-02").startOf("day"),
          paymentDate: "February 2, 2022",
          salesPeriod: "November 27 - December 31",
          focusDate: DT.fromISO("2022-12-01").startOf("day"),
        },
      ],
      "Mar 9, 2023"
    ),
    month(
      DT.fromISO("2023-02-01"),
      DT.fromISO("2023-02-05"),
      DT.fromISO("2023-03-04"),
      [],
      "Apr 6, 2023"
    ),
    month(
      DT.fromISO("2023-03-01"),
      DT.fromISO("2023-03-05"),
      DT.fromISO("2023-04-01"),
      [
        {
          date: DT.fromISO("2023-03-09").startOf("day"),
          paymentDate: "March 9, 2023",
          salesPeriod: "January 1 - February 4",
          focusDate: DT.fromISO("2023-01-01").startOf("day"),
        },
      ],
      "May 4, 2023"
    ),
  ]),
  quarter("Apr 2 - Jul 1", [
    month(
      DT.fromISO("2023-04-01"),
      DT.fromISO("2023-04-02"),
      DT.fromISO("2023-05-06"),
      [
        {
          date: DT.fromISO("2023-04-06").startOf("day"),
          paymentDate: "April 6, 2023",
          salesPeriod: "February 5 - March 4",
          focusDate: DT.fromISO("2023-02-01").startOf("day"),
        },
        {
          date: DT.fromISO("2023-05-04").startOf("day"),
          paymentDate: "May 4, 2023",
          salesPeriod: "March 5 - April 1",
          focusDate: DT.fromISO("2023-03-01").startOf("day"),
        },
      ],
      "June 8, 2023"
    ),
    month(
      DT.fromISO("2023-05-01"),
      DT.fromISO("2023-05-07"),
      DT.fromISO("2023-06-03"),
      [],
      "July 6, 2023"
    ),
    month(
      DT.fromISO("2023-06-01"),
      DT.fromISO("2023-06-04"),
      DT.fromISO("2023-07-01"),
      [
        {
          date: DT.fromISO("2023-06-08").startOf("day"),
          paymentDate: "June 8, 2023",
          salesPeriod: "April 2 - May 6",
          focusDate: DT.fromISO("2023-04-01").startOf("day"),
        },
      ],
      "Aug 3, 2023"
    ),
  ]),
  quarter("Jun 26 - Sep 24", [
    month(
      DT.fromISO("2023-07-01"),
      DT.fromISO("2023-07-02"),
      DT.fromISO("2023-08-05"),
      [
        {
          date: DT.fromISO("2023-07-06").startOf("day"),
          paymentDate: "July 6, 2023",
          salesPeriod: "May 7 - June 3",
          focusDate: DT.fromISO("2023-05-01").startOf("day"),
        },
        {
          date: DT.fromISO("2023-08-03").startOf("day"),
          paymentDate: "August 3, 2023",
          salesPeriod: "June 4 - July 1",
          focusDate: DT.fromISO("2023-06-01").startOf("day"),
        },
      ],
      "Sept 7, 2023"
    ),
    month(
      DT.fromISO("2023-08-01"),
      DT.fromISO("2023-08-06"),
      DT.fromISO("2023-09-02"),
      []
    ),
    month(
      DT.fromISO("2023-09-01"),
      DT.fromISO("2023-09-03"),
      DT.fromISO("2023-09-30"),
      [
        {
          date: DT.fromISO("2023-09-07").startOf("day"),
          paymentDate: "September 7, 2023",
          salesPeriod: "July 2 - August 5",
          focusDate: DT.fromISO("2023-07-01").startOf("day"),
        },
      ]
    ),
  ]),
];

function Description({ title = "2021 Apple Payment Dates" }) {
  return (
    <div className={styles.description}>
      <label className={styles.label}>{title}</label>
      <br />
      <p className={styles.center}>
        Estimated payment dates in blue. Hover or tap to reveal its sales dates.
      </p>
      <br />
      <br />
    </div>
  );
}

function CalendarFooter({
  text = "Apple will release the 2023 fiscal calendar in September of 2022. We will update the calendar once the next fiscal calendar arrives.",
}) {
  return (
    <>
      <p className={`${styles.textCenter}`}>
        <span className={`${styles.filled}`}>
          This calendar is an estimation because Apple doesn’t publish the
          official payout dates.
        </span>
      </p>
      <br />
      <p className={`${styles.textCenter}`}>
        <span className={`${styles.filled}`}>
          Apple will release the 2024 fiscal calendar in September of 2023. We
          will update the
          <br />
          calendar once the next fiscal calendar arrives.
        </span>
      </p>
      <br />
      <br />
      <InAppSubscriptionForm />
      <div className={styles.footer}>
        <EllipseYellow className={styles.ellipseGreen} />
        <div className={styles.link}>
          <a
            className={styles.label}
            href="https://itunesconnect.apple.com/WebObjects/iTunesConnect.woa/wa/jumpTo?page=fiscalcalendar"
            onClick={() => track("fiscal_calendar_app_store_link_clicked")}
            target="_blank"
          >
            <CheckIcon />
            <span>App Store Connect Link</span>
          </a>
          <div className={styles.text}>Sign-in required</div>
        </div>
        <div className={styles.link}>
          <a
            download
            onClick={() => track("fiscal_calendar_pdf_link_clicked")}
            className={styles.label}
            href={"/apple-fiscal-calendar-2023.pdf"}
            target="_blank"
          >
            <DocIcon />
            <span>PDF File</span>
          </a>
          <div className={styles.text} />
        </div>
        <div className={styles.link}>
          <Link href="/fiscal-calendar-2022">
            <a className={styles.label}>
              <CalendarIcon />
              <span>
                Apple’s Fiscal Calendar
                <br />
                and Payment Dates 2022
              </span>
            </a>
          </Link>
          <div className={styles.text} />
        </div>
        <EllipseGreen className={styles.ellipseYellow} />
      </div>
    </>
  );
}

export default function FiscalCalendar() {
  return (
    <div className="wrapper">
      <Head>
        <title>Apple’s Fiscal Calendar and Payment Dates 2023 - Apphud</title>
        <link
          rel="canonical"
          href="https://apphud.com/fiscal-calendar-2023"
        />
        <meta
          name="title"
          content="Apple Fiscal Calendar and Payment Dates 2023 - Apphud"
        />
        <meta
          name="description"
          content="Apple App Store payment cycles are confusing to even experienced developers and companies."
        />
      </Head>
      <div className="title-block">
        <div className="container">
          <h1>
            Apple’s Fiscal Calendar
            <br />
            and Payment Dates 2023
          </h1>
          <p>Be aware of when you’ll get paid for the App Store earnings</p>
        </div>
      </div>
      <div className="container">
        <div className={styles2.description}>
          <div className={styles2.item}>
            <p>
              Apple’s fiscal year consists of Q1, Q2, Q3, and Q4 quarters, each
              with one 35-day month and two 28-day months. The fiscal year
              starts in October, so Apple’s fiscal 2023 started with Q1 in
              October 2022.
            </p>
            <p>
              Apple usually pays 33 days after the end of each fiscal month
              (with rare exceptions). So roughly speaking, it’s 4 weeks + 5
              days.
            </p>
            <p>
              This tool is for reference only, exact payment dates may vary!
            </p>
          </div>
          <div className={styles2.item}>
            <Img />
          </div>
        </div>
        <AppleFiscalCalendar
          quarters={quarters}
          title="2023 Apple Payment Dates"
          DescriptionCmp={Description}
          CalendarFooterCmp={CalendarFooter}
        />
      </div>
    </div>
  );
}
